
export interface UserDto {
  id?: string;
  name: string;
  surname: string;
  email: string;
  fullName: string;
}

export interface UserInputDto {
  id?: string;
  filter?: string;
}
